var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { parse } from 'query-string';
import * as React from "react";
import { NavLink } from "react-router-dom";
import { Button, Dimmer, Form, Input, Loader, Message } from "semantic-ui-react";
import ErrorDisplay from "./ErrorDisplay";
import FieldWithErrorDisplay from "./FieldWithErrorDisplay";
import { postJsonNoAuthn } from "./RequestHelpers";
var ResetPasswordPage = /** @class */ (function (_super) {
    __extends(ResetPasswordPage, _super);
    function ResetPasswordPage(props) {
        var _this = _super.call(this, props) || this;
        _this.onVerify = function () {
            _this.setState({
                loading: true
            }, function () {
                var reqBody = {
                    email: _this.state.email,
                    token: _this.state.token,
                    password: _this.state.password
                };
                postJsonNoAuthn('/user/reset-password', JSON.stringify(reqBody))
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            errors: [],
                            success: true
                        });
                        return;
                    }
                    else if (resp.status === 400) {
                        return resp.json();
                    }
                    else {
                        _this.setState({
                            loading: false,
                            errors: [{
                                    path: '/',
                                    msg: 'An unexpected error occurred'
                                }],
                            success: false
                        });
                        return;
                    }
                })
                    .then(function (resp) {
                    if (resp !== undefined) {
                        _this.setState({
                            errors: resp.errors,
                            loading: false
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't reset password: " + rej);
                });
            });
        };
        _this.onPasswordChange = function (event) {
            var str = event.currentTarget.value;
            _this.setState({
                password: str
            });
        };
        var search = parse(props.history.location.search);
        _this.state = {
            loading: false,
            errors: [],
            success: false,
            email: ('email' in search && typeof search.email === 'string') ? search.email : '',
            token: ('token' in search && typeof search.token === 'string') ? search.token : '',
            password: ''
        };
        return _this;
    }
    ResetPasswordPage.prototype.render = function () {
        return React.createElement("div", { id: "non-header-portion" },
            React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.errors.length > 0, success: this.state.success },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                React.createElement("p", null,
                    "Email: ",
                    this.state.email),
                React.createElement(FieldWithErrorDisplay, { disabled: this.state.success, errorPath: '/password', errors: this.state.errors, labelContent: React.createElement(React.Fragment, null, "Password"), required: true },
                    React.createElement(Input, { value: this.state.password, onChange: this.onPasswordChange, type: 'password' })),
                React.createElement(ErrorDisplay, { errors: this.state.errors, errorPath: '/' }),
                this.state.success
                    && React.createElement(Message, { success: true },
                        React.createElement(Message.Header, null, "Password reset"),
                        "You may now ",
                        React.createElement(NavLink, { to: '/user/log-in' }, "log in"),
                        "."),
                React.createElement(Button, { disabled: this.state.success, icon: 'privacy', label: 'Reset password', labelPosition: 'left', positive: true, onClick: this.onVerify })));
    };
    return ResetPasswordPage;
}(React.PureComponent));
export default ResetPasswordPage;
//# sourceMappingURL=ResetPasswordPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/ResetPasswordPage.js
// module id = 1201
// module chunks = 0